import 'assets/scss/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import { Loader, NotificationBar } from './components';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { getEnv } from './utils';
import { Helmet } from "react-helmet";

// Segurança: o token de autenticação vive APENAS no HttpOnly cookie (definido
// pelo server.js). Nunca armazenamos token em localStorage — esta limpeza
// remove qualquer valor residual de versões antigas do portal.
['@sta-token', '@sta-token-expiration', '@sta-user-token'].forEach((key) => {
    try { window.localStorage.removeItem(key); } catch (e) { /* ignore */ }
});

ReactDOM.render(
  <Provider store={store} >
    <Suspense fallback={<Loader visible={true} />}>
      <NotificationBar>
        Atenção: Se você está em busca do portal Santillana Español,{" "}
        <a href="https://www.santillanaespanol.com.br">clique aqui.</a>
      </NotificationBar>
      {
        getEnv() === 'hml' && window.location.search.indexOf('type=print') < 0 ? <Helmet>
          <script type="text/javascript" id="PrivallyApp" src="https://app.privally.global/app.js" pid="38bb06-f2bc9a" async></script>
        </Helmet>
          : null
      }
      <Helmet>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.1/font/bootstrap-icons.css"></link>
      </Helmet>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
